import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Group, Tooltip } from "@mantine/core";
export const ChipGroup = ({ items, size = "sm", color = "gray", limit = 4, onClick }) => {
    // Data
    const displayItems = items?.slice(0, limit);
    const remainingItems = items?.slice(limit);
    const overflowCount = items?.length ? items.length - limit : 0;
    const overflowItem = overflowCount > 0
        ? {
            label: `+${overflowCount}`
        }
        : null;
    // Handlers
    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onClick?.();
    };
    return (_jsxs(Group, { gap: "xs", wrap: "wrap", onClick: handleClick, children: [displayItems?.map((item, index) => (_jsx(Badge, { autoContrast: true, size: size, color: color, style: { cursor: "pointer" }, children: item.label }, index))), overflowItem && (_jsx(Tooltip, { withArrow: true, openDelay: 300, closeDelay: 100, label: remainingItems?.map((item) => item.label).join(", "), children: _jsx(Badge, { autoContrast: true, size: size, color: color, style: { cursor: "pointer" }, children: overflowItem.label }, overflowItem.label) }, overflowItem.label))] }));
};
